/* @ts-self-types="./moshon_dsp.d.ts" */

export class AdsbDemod {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AdsbDemodFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_adsbdemod_free(ptr, 0);
    }
    /**
     * Return all pending frames as a JSON array string, draining the
     * internal buffer. JSON is the simplest cross-WASM-boundary format
     * for variable-length structured data.
     * @returns {string}
     */
    drain_frames_json() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.adsbdemod_drain_frames_json(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Cumulative frame count since construction (does not reset on drain).
     * Used by the UI to display a "frames decoded" telemetry counter even
     * when there's no current activity.
     * @returns {number}
     */
    get frame_count() {
        const ret = wasm.adsbdemod_frame_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} sample_rate_hz
     */
    constructor(sample_rate_hz) {
        const ret = wasm.adsbdemod_new(sample_rate_hz);
        this.__wbg_ptr = ret;
        AdsbDemodFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Feed a chunk of IQ samples. Decoded frames pile up internally;
     * drain them with `drain_frames_json()`.
     * @param {Uint8Array} iq_bytes
     */
    process(iq_bytes) {
        const ptr0 = passArray8ToWasm0(iq_bytes, wasm.__wbindgen_export2);
        const len0 = WASM_VECTOR_LEN;
        wasm.adsbdemod_process(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) AdsbDemod.prototype[Symbol.dispose] = AdsbDemod.prototype.free;

/**
 * AM envelope-detector demodulator. Default bandwidth 9 kHz (broadcast AM).
 * Decimates 2.4 MS/s → 240 kS/s → 48 kS/s with a channel filter, then
 * envelope-detects (|z|) and removes the carrier DC with a single-pole
 * IIR high-pass.
 */
export class AmDemod {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AmDemodFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_amdemod_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    get is_squelch_open() {
        const ret = wasm.amdemod_is_squelch_open(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {number} input_rate_hz
     * @param {number} bandwidth_hz
     */
    constructor(input_rate_hz, bandwidth_hz) {
        const ret = wasm.amdemod_new(input_rate_hz, bandwidth_hz);
        this.__wbg_ptr = ret;
        AmDemodFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Uint8Array} iq_bytes
     * @returns {Float32Array}
     */
    process(iq_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(iq_bytes, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.amdemod_process(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayF32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_export(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * See `NfmDemod::set_squelch_db`. AM uses the same envelope-based
     * gate keyed off |z|.
     * @param {number} db
     */
    set_squelch_db(db) {
        wasm.amdemod_set_squelch_db(this.__wbg_ptr, db);
    }
}
if (Symbol.dispose) AmDemod.prototype[Symbol.dispose] = AmDemod.prototype.free;

export class CwDemod {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CwDemodFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cwdemod_free(ptr, 0);
    }
    /**
     * @param {number} input_rate_hz
     * @param {number} bandwidth_hz
     */
    constructor(input_rate_hz, bandwidth_hz) {
        const ret = wasm.cwdemod_new(input_rate_hz, bandwidth_hz);
        this.__wbg_ptr = ret;
        CwDemodFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Uint8Array} iq_bytes
     * @returns {Float32Array}
     */
    process(iq_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(iq_bytes, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.cwdemod_process(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayF32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_export(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) CwDemod.prototype[Symbol.dispose] = CwDemod.prototype.free;

/**
 * One-shot FFT processor: takes a contiguous block of 8-bit unsigned IQ
 * samples (interleaved I, Q, I, Q, …), applies a window, runs an FFT, and
 * returns a vector of log-magnitudes in dBFS — fftshifted so DC is at the
 * centre.
 */
export class FftContext {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FftContextFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_fftcontext_free(ptr, 0);
    }
    /**
     * `size` must be a power of two between 64 and 16384.
     * @param {number} size
     */
    constructor(size) {
        const ret = wasm.fftcontext_new(size);
        this.__wbg_ptr = ret;
        FftContextFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Process exactly `size` IQ samples (= `size * 2` bytes).
     * Returns a `Float32Array` of log-magnitudes in dBFS, fftshifted.
     * Returns an empty array if `iq.len() < size * 2`.
     * @param {Uint8Array} iq
     * @returns {Float32Array}
     */
    process(iq) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(iq, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.fftcontext_process(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayF32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_export(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    get size() {
        const ret = wasm.fftcontext_size(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) FftContext.prototype[Symbol.dispose] = FftContext.prototype.free;

/**
 * Narrowband-FM demodulator. Default bandwidth 12.5 kHz (typical ham
 * voice channel). Decimates 2.4 MS/s → 240 kS/s → 48 kS/s, then runs an
 * FM discriminator on the 48 kS/s IQ stream.
 */
export class NfmDemod {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NfmDemodFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_nfmdemod_free(ptr, 0);
    }
    /**
     * True when the squelch is currently open (audio passing).
     * @returns {boolean}
     */
    get is_squelch_open() {
        const ret = wasm.nfmdemod_is_squelch_open(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {number} input_rate_hz
     * @param {number} bandwidth_hz
     */
    constructor(input_rate_hz, bandwidth_hz) {
        const ret = wasm.nfmdemod_new(input_rate_hz, bandwidth_hz);
        this.__wbg_ptr = ret;
        NfmDemodFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Uint8Array} iq_bytes
     * @returns {Float32Array}
     */
    process(iq_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(iq_bytes, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.nfmdemod_process(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayF32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_export(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Set the squelch threshold in dBFS, where 0 dBFS = unit-magnitude
     * post-channel-filter envelope. Pass a value ≤ -120 to disable
     * (audio always passes). Typical useful range is -50..-10 dBFS.
     * @param {number} db
     */
    set_squelch_db(db) {
        wasm.nfmdemod_set_squelch_db(this.__wbg_ptr, db);
    }
}
if (Symbol.dispose) NfmDemod.prototype[Symbol.dispose] = NfmDemod.prototype.free;

/**
 * Weaver-method single-sideband demodulator.
 */
export class SsbDemod {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SsbDemodFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ssbdemod_free(ptr, 0);
    }
    /**
     * @param {number} input_rate_hz
     * @param {number} bandwidth_hz
     * @param {boolean} lsb
     */
    constructor(input_rate_hz, bandwidth_hz, lsb) {
        const ret = wasm.ssbdemod_new(input_rate_hz, bandwidth_hz, lsb);
        this.__wbg_ptr = ret;
        SsbDemodFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {Uint8Array} iq_bytes
     * @returns {Float32Array}
     */
    process(iq_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(iq_bytes, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.ssbdemod_process(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayF32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_export(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) SsbDemod.prototype[Symbol.dispose] = SsbDemod.prototype.free;

/**
 * Wideband-FM demodulator with optional stereo MPX decode.
 *
 * Chain:
 *   1. 2.4 MS/s IQ → 240 kS/s IF via 10:1 windowed-sinc decimation.
 *   2. FM discriminator → real-valued MPX at 240 kS/s.
 *   3a. MPX → audio LPF + 5:1 decimation → 48 kS/s L+R sum.
 *   3b. If stereo detected: pilot biquad-BPF → square → biquad-BPF at 38 kHz
 *       → multiply MPX by this coherent reference → audio LPF + 5:1
 *       decimation → 48 kS/s L-R difference.
 *   4. L = sum + diff, R = sum - diff. 50 µs de-emphasis per channel.
 *   5. Output interleaved L,R `Float32Array` at 48 kS/s.
 *
 * When the pilot is absent or stereo is disabled, the output is still
 * interleaved with L = R = mono so the caller doesn't need to switch ring
 * layouts mid-stream.
 */
export class WfmDemod {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WfmDemodFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wfmdemod_free(ptr, 0);
    }
    /**
     * True when the smoothed pilot envelope exceeds the threshold AND
     * stereo decoding is enabled. Updated each `process()` call.
     * @returns {boolean}
     */
    get is_stereo_locked() {
        const ret = wasm.wfmdemod_is_stereo_locked(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Construct a WFM demodulator for the given input IQ sample rate.
     * Supported rates: any integer multiple of `WFM_IF_RATE` (240 kHz)
     * that the dongle can actually deliver — e.g. 1.92, 2.4, 2.88, 4.8,
     * 9.6 MS/s. Non-integer ratios round to the nearest integer; the IF
     * rate may then drift slightly from 240 kHz (acceptable for ear).
     * @param {number} input_rate_hz
     */
    constructor(input_rate_hz) {
        const ret = wasm.wfmdemod_new(input_rate_hz);
        this.__wbg_ptr = ret;
        WfmDemodFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Process a chunk of 8-bit unsigned IQ at 2.4 MS/s. Returns interleaved
     * stereo audio (L, R, L, R, …) at 48 kS/s.
     * @param {Uint8Array} iq_bytes
     * @returns {Float32Array}
     */
    process(iq_bytes) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(iq_bytes, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.wfmdemod_process(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v2 = getArrayF32FromWasm0(r0, r1).slice();
            wasm.__wbindgen_export(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 16-bit Program Identification code from the most-recent block A.
     * Zero before the first sync.
     * @returns {number}
     */
    get rds_pi() {
        const ret = wasm.wfmdemod_rds_pi(this.__wbg_ptr);
        return ret;
    }
    /**
     * Program Service name — 8 ASCII characters, padded with spaces.
     * Each pair of characters arrives in a Group 0A; the buffer is updated
     * in place so partial PS may include leftover bytes from a previous
     * station for a few hundred ms after retuning.
     * @returns {string}
     */
    rds_ps() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.wfmdemod_rds_ps(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Radio Text — up to 64 ASCII characters from Group 2A. Stations may
     * send shorter strings terminated by 0x0D — we leave that to the
     * caller to trim.
     * @returns {string}
     */
    rds_rt() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.wfmdemod_rds_rt(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * True once the RDS block-sync state machine has locked.
     * @returns {boolean}
     */
    get rds_synced() {
        const ret = wasm.wfmdemod_rds_synced(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Clear the RDS decoder state. Call after a retune so leftover PS
     * chars from the previous station don't bleed into the new one.
     */
    reset_rds() {
        wasm.wfmdemod_reset_rds(this.__wbg_ptr);
    }
    /**
     * Set the audio de-emphasis time constant in microseconds. Standard
     * values are 50 µs (ITU R1 / Europe) and 75 µs (North America). The
     * coefficient is recomputed; existing filter state is preserved so
     * there's no click on the transition.
     * @param {number} us
     */
    set_deemphasis_us(us) {
        wasm.wfmdemod_set_deemphasis_us(this.__wbg_ptr, us);
    }
    /**
     * Whether to attempt stereo decode when the 19 kHz pilot is present.
     * When disabled, output is L=R=mono regardless of the pilot.
     * @param {boolean} enabled
     */
    set_stereo_enabled(enabled) {
        wasm.wfmdemod_set_stereo_enabled(this.__wbg_ptr, enabled);
    }
}
if (Symbol.dispose) WfmDemod.prototype[Symbol.dispose] = WfmDemod.prototype.free;

/**
 * @returns {number}
 */
export function smoke() {
    const ret = wasm.smoke();
    return ret >>> 0;
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_throw_9c31b086c2b26051: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
    };
    return {
        __proto__: null,
        "./moshon_dsp_bg.js": import0,
    };
}

const AdsbDemodFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_adsbdemod_free(ptr, 1));
const AmDemodFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_amdemod_free(ptr, 1));
const CwDemodFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cwdemod_free(ptr, 1));
const FftContextFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_fftcontext_free(ptr, 1));
const NfmDemodFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_nfmdemod_free(ptr, 1));
const SsbDemodFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ssbdemod_free(ptr, 1));
const WfmDemodFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wfmdemod_free(ptr, 1));

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let cachedFloat32ArrayMemory0 = null;
function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasmInstance, wasm;
function __wbg_finalize_init(instance, module) {
    wasmInstance = instance;
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedFloat32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('moshon_dsp_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
